export default {
  blank: () => import("/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/src/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/src/layouts/default.vue").then(m => m.default || m)
}